import React, { FC, useEffect, useMemo, useRef, useState } from "react"
import { Trans, useTranslation } from "react-i18next"
import tickingreencircleSvg from "@/assets/images/clinical/tickingreencircle.svg"
import { FormInput, UButton, UText } from "../../../components"
import {
  Box,
  Button,
  Divider,
  Grid,
  TextField,
  Switch,
} from "../../../components/mui.components"
import { useAppDispatch, useAppSelector } from "../../../core/app/hooks"

import usePermissions from "../../../hooks/userPermission"
import EasyRxConnect from "./EasyRxConnect"
import AddScanner from "./AddScanner"
import ScannerBox from "./ScannerBox"
import { useSearchParams } from "react-router-dom"

import {
  getMeditToken,
  getMeditGroupUuid,
} from "../../../core/global/httpMedit"
import {
  get3ShapeToken,
  get3ShapeCaselist,
  downloadScan,
  refreshToken,
} from "../../../core/global/http3Shape"
import useLocalStorageListener from "./localStorageHooks"
import DialogBox from "@/modules/Clinical/components/DialogBox/dialogBox"
import { UModalPopup } from "../../../ui-component"
import { FlashlightOnRounded } from "@mui/icons-material"
const originSetItem = localStorage.setItem
const safeJSONParse = (value: string) => {
  try {
    return JSON.parse(value)
  } catch {
    return value
  }
}

localStorage.setItem = function (key, value) {
  const event = new CustomEvent("localStorageChange", {
    detail: { key, value: safeJSONParse(value) },
  })
  originSetItem.call(this, key, value)
  window.dispatchEvent(event)
}

const originRemoveItem = localStorage.removeItem
localStorage.removeItem = function (key) {
  const event = new CustomEvent("localStorageChange", {
    detail: { key, value: null },
  })
  originRemoveItem.call(this, key)
  window.dispatchEvent(event)
}
const Integrations: FC = () => {
  const { hasAny } = usePermissions()
  const { t } = useTranslation("common")

  const dispatch = useAppDispatch()
  // easyRx switch
  const [easyRxSwitch, setEasyRxSwitch] = useState<boolean>(false)
  // scanner add
  const [sAdd, setSAdd] = useState<boolean>(false)
  const [scannerData, setScannerData] = useState([])

  const [searchParams] = useSearchParams()
  // locastorage key  3shapeData， meditData, alliesData
  const shapeLocal = useLocalStorageListener("3shapeData", null)
  const meditDataLocal = useLocalStorageListener("meditData", null)
  const alliesDataLocal = useLocalStorageListener("alliesData", null)
  const [openDisconnectPopup, setOpenDisconnectPopup] = useState<boolean>(false)
  const [openConnectPopup, setOpenConnectPopup] = useState<boolean>(false)
  const [addConnectedName, setAddConnectedName] = useState<string>("")
  const [deleteStorageObj, setDeleteStorageObj] = useState({
    name: "",
    key: "",
    isPrimary: false,
    localName: "",
  })

  const { VITE_DOMAIN } = import.meta.env
  useEffect(() => {
    const backURL = window.location.href

    const handleIntegration = async () => {
      if (backURL.includes("3shape.com")) {
        const code = searchParams.get("code")
        console.log("code=", code)

        if (code) {
          const isGetToken = await get3ShapeToken(code)
          if (isGetToken) {
            setAddConnectedName("3Shape")
            setOpenConnectPopup(true)
          }
        }
        // 清掉 searchParams
        window.history.replaceState({}, "", window.location.pathname)
      } else if (backURL.includes("openid")) {
        const openid = searchParams.get("openid")
        console.log("openid=", openid)
        if (openid) {
          const shapeScanner = localStorage.getItem("3shapeData")
          const meditScanner = localStorage.getItem("meditData")
          localStorage.setItem(
            "alliesData",
            JSON.stringify({
              openid: openid,
              realName: searchParams.get("realName"),
              avatar: searchParams.get("avatar"),
              nickName: searchParams.get("nickName"),
              email: searchParams.get("email"),
              region: searchParams.get("region"),
              unionid: searchParams.get("unionid"),
              isPrimary: !shapeScanner && !meditScanner ? true : false,
            }),
          )
          setAddConnectedName("Alliedstar")
          setOpenConnectPopup(true)
          window.history.replaceState({}, "", window.location.pathname)
        }
      } else if (backURL.includes("medit")) {
        const code = searchParams.get("code")
        console.log("code=", code)

        if (code) {
          const isgetMediToken = await getMeditToken(code)
          if (isgetMediToken) {
            setAddConnectedName("Medit")
            setOpenConnectPopup(true)
          }
        }
        window.history.replaceState({}, "", window.location.pathname)
      }
    }

    handleIntegration()

    return () => {
      console.log("组件卸载")
    }
  }, [searchParams])

  useEffect(() => {
    const tmp = []
    if (shapeLocal) {
      const shapeScanner = JSON.parse(
        localStorage.getItem("3shapeData") || "{}",
      )
      tmp.push({
        name: "3Shape",
        key: "3Shape",
        isPrimary: shapeScanner.isPrimary,
        localName: "3shapeData",
      })
    }
    if (meditDataLocal) {
      const meditScanner = JSON.parse(localStorage.getItem("meditData") || "{}")

      tmp.push({
        name: "Medit",
        key: "Medit",
        isPrimary: meditScanner.isPrimary,
        localName: "meditData",
      })
    }
    if (alliesDataLocal) {
      const allieScanner = JSON.parse(
        localStorage.getItem("alliesData") || "{}",
      )
      tmp.push({
        name: "Alliedstar",
        key: "Alliedstar",
        isPrimary: allieScanner.isPrimary,
        localName: "alliesData",
      })
    }
    setScannerData(tmp)
  }, [shapeLocal, meditDataLocal, alliesDataLocal])
  return (
    <>
      <Grid sx={{ width: "600px", p: 4 }}>
        <UText
          variant={"h4"}
          component={"div"}
          sxProp={{ textAlign: "center", pb: 2 }}
        >
          {t("settings.Integrations.title")}
        </UText>
        {/* <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <UText
            variant={"h5"}
            component={"div"}
            sxProp={{ textAlign: "center", pb: 1 }}
          >
            {`EasyRx`}
          </UText>
          <Switch
            checked={easyRxSwitch}
            onChange={() => {
              setEasyRxSwitch(!easyRxSwitch)
            }}
          />
        </Box>
        {easyRxSwitch && <EasyRxConnect />}
        <Divider sx={{ my: 4 }} /> */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <UText
            variant={"h5"}
            component={"div"}
            sxProp={{ textAlign: "center", pb: 1 }}
          >
            {`Scanner`}
          </UText>
          <Button
            variant={"text"}
            sx={{
              minWidth: "auto",
              height: "auto",
              width: "auto",
              lineHeight: "22px",
              py: "4px",
              px: "5px",
            }}
            onClick={() => {
              setSAdd(!sAdd)
            }}
          >
            {sAdd ? `CANCEL` : `ADD`}
          </Button>
        </Box>
        {sAdd && (
          <AddScanner
            scannerData={scannerData}
            setScannerData={setScannerData}
          />
        )}
        {scannerData.map((i, j) => {
          return (
            <ScannerBox
              key={i.key}
              scannerObjData={i}
              isDivider={j !== scannerData.length - 1 ? true : false}
              setDeleteStorageObj={setDeleteStorageObj}
              setOpenDisconnectPopup={setOpenDisconnectPopup}
            />
          )
        })}
      </Grid>
      <DialogBox
        open={openDisconnectPopup}
        title="Disconnect Scanner"
        content={
          <>
            <br />
            {"Are you sure you want to disconnect your "}
            <strong>{deleteStorageObj.name}</strong> {"scanner?"}
          </>
        }
        actions={
          <>
            <UButton
              onClickHandler={() => {
                setOpenDisconnectPopup(false)
              }}
              variant={"text"}
              btnText={"Cancel"}
            />
            <UButton
              onClickHandler={() => {
                let preparatoryPrimary = ""
                if (deleteStorageObj.isPrimary && scannerData.length > 1) {
                  scannerData.forEach((item) => {
                    if (item.name !== deleteStorageObj.name) {
                      preparatoryPrimary = item.localName
                    }
                  })
                }
                if (deleteStorageObj.name === "3Shape") {
                  let jsonObj = JSON.parse(localStorage.getItem("3shapeData"))
                  const disconnectURL = `https://identity.3shape.com/connect/endsession?id_token_hint=${jsonObj.accessToken}&post_logout_redirect_uri=${VITE_DOMAIN}/settings/integrations&state=Success`
                  localStorage.removeItem(deleteStorageObj.localName)
                  window.open(disconnectURL, "_blank")
                } else {
                  localStorage.removeItem(deleteStorageObj.localName)
                }
                setOpenDisconnectPopup(false)
                if (preparatoryPrimary !== "") {
                  const userStr = localStorage.getItem(preparatoryPrimary)
                  if (userStr) {
                    const userObj = JSON.parse(userStr)
                    userObj.isPrimary = true
                    localStorage.setItem(
                      preparatoryPrimary,
                      JSON.stringify(userObj),
                    )
                  }
                }
              }}
              variant={"contained"}
              btnText={"Yes"}
            />
          </>
        }
      ></DialogBox>
      <UModalPopup
        isAlert={openConnectPopup}
        title={
          <>
            <img
              src={tickingreencircleSvg}
              alt=""
              style={{ margin: "4px 10px 0 0" }}
            />
            {"Scanner Connected"}
          </>
        }
        content={
          <>
            {"Your"} <strong>{addConnectedName}</strong>{" "}
            {"scanner has been connected."}
            <br />
            <br />
            {"Scans may now be imported from your scanner during the"}{" "}
            <strong>{"Add Patient"}</strong> {"workflow."}
          </>
        }
        sxModalProps={{
          ".MuiDialog-paper": {
            maxWidth: 444,
          },
          "#titleCntr": {
            padding: "18px 24px",
          },
          "#contentCntr": {
            padding: "20px 24px",
          },
          "#btnListCntr": {
            padding: 1,
            gap: 1,
          },
        }}
        btnList={[
          <UButton
            onClickHandler={() => {
              setOpenConnectPopup(false)
            }}
            variant={"contained"}
            btnText={"OK"}
          />,
        ]}
      ></UModalPopup>
    </>
  )
}

export default Integrations
